import { render, staticRenderFns } from "./CommunicationTypeActivity.vue?vue&type=template&id=40799410"
import script from "./CommunicationTypeActivity.vue?vue&type=script&lang=ts"
export * from "./CommunicationTypeActivity.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationTypeActivity.vue?vue&type=style&index=0&id=40799410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports